module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $, undefined) {
	fox.registerWidget('Dialog', {
		configure: function(options) {
			this.registerOptions('', {
				'embed.widget': '@root',
				template: 'dialog_global_body',
				autoRender: true,
				useUiPosition: false,
				preventHideOnShadowClick: false,
				preventHideOtherPopups: false,
				dialog: {
					show: {
						effect: 'fade',
						duration: 400
					},
					minHeight: 'auto',
					autoOpen: false,
					modal: true,
					resizable: false,
					close: fox.bind(this.hide, this),
				}
			});

			this.registerOptions('.Controller', {
				'embed.container': '.ui-dialog-content'
			});			
			
			this.callParent('configure', arguments);
		},

		_render: function () {
			return this.callParent('_render', [true]);
		},

		embed: function() {
			var div = document.createElement('div');
			div.appendChild(this.fragment);

			this.dialog = $(div).dialog(this.getOption('dialog'));

			if (this.getOption('template')) {
				this.element = this.dialog[0];
			} else {
				var widget = this.dialogMethod('widget');
				this.element = [widget[0]];
			}

			this.embedCall = true;
		},

		init: function() {
			var buttonsOption = this.getOption('dialog.buttons');

			this.embedCall = false;
			
			if (buttonsOption && buttonsOption.length) {
				fox.each(buttonsOption, function (val) {
					val.click = function () {};
				}, this);
			}

			if (this.getOption('useUiPosition') === true) {
				this.registerOptions('.Widget', {
					handleWom: {
						childsAddedToDom: {
							event: 'addedToDom',
							widget: '@this',
							callback: fox.bind(this._center, this),
							'params.prefix': 'childsAddedToDom'
						}
					}
				});
			} else {
				this.registerOptions('.Widget', {
					handleWom: {
						childsAddedToDom: {
							event: 'addedToDom',
							widget: '@this',
							callback: fox.bind(this.centerPopup, this),
							'params.prefix': 'childsAddedToDom'
						}
					}
				});
			}
			
			this.callParent('init', arguments);
		},

		dialogMethod: function(method) {
			return $(this.dialog).dialog(method);
		},

		centerPopup: function () {
			if (!this.element) {
				return;
			}
			setTimeout(fox.bind(function (){
				var elWidth = this.element[0].offsetWidth,
				elHeight = this.element[0].offsetHeight;
				$(this.element[0]).css({
					left: parseInt(($(window).width() - elWidth) / 2 * 100 / $(window).width()) + '%',
					top: parseInt(($(window).height() - elHeight) / 2 * 100 / $(window).height()) + '%'
				});
			}, this), 50);
		},

		show: function() {
			if (this.getOption('preventHideOtherPopups') === true) {
				if (fox.wom.select('~.Mixin_DocumentWidget').some(function (w) {return w.isOpen() === true;})) {
					this.dialog.dialog('option', 'modal', false);

					this.waitEvent('@this', 'hide', function (params, _this) {
						_this.dialog.dialog('option', 'modal', true);
					}, {prefix: 'resetModal'});	
				}
			} else {
				fox.each(fox.wom.select('~.Mixin_DocumentWidget'), function(w) {
					if (w.getId() != this.getId() && w.isOpen()) {
						w.hide();
					}
				}, this);
			}

			if (this.embedCall === false) {
				this.embed();
			}
			
			if (!this._indom) {
				this.afterEmbed();
			}

			this.dispatchEvent('show');

			if (!this.getOption('preventHideOnShadowClick')) {
				$(document).one('click', '.ui-widget-overlay', fox.bind(this.hide, this));
			}

			if (!this.isOpen()) {
				this.dialogMethod('open');
				
				if (this.wom('.Widget').length > 0) {
					this.dispatchEvent('addedToDom');
				}
			}
			
			return this;
		},

		hide: function() {
			this.callParent('hide', arguments);

			if (!this.getOption('preventHideOnShadowClick')) {
				$(document).off('click', '.ui-widget-overlay');
			}

			this.dialogMethod('close');

			return this;
		},

		_center: function () {
			if (this.dialog) {
				this.dialog.dialog(
					'option', 'position', this.getOption('dialog.position') || 
					{ my: 'center', at: 'center', of: window }
				);
			}

			return this;
		},

		setTitle: function (title) {
			if (this.embedCall === false) {
				this.embed();
			}

			this.dialog.dialog('option', 'title', title);

			return this;
		},

		reset: function () {
			if (this.embedCall === false) {
				this.embed();
			}

			this.dialog.dialog( "option", this.getOption('dialog') );
			return this;
		},

		isOpen: function () {
			var isOpen = this.dialogMethod('isOpen');

			return isOpen.length === 0 ? false : isOpen;
		},

		deactivate: function () {
			if (this.isOpen()) {
				this.callParent('deactivate', arguments);
			}
		}

	}, 'Mixin_DocumentWidget');

})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/dialog.js
// module id = 186
// module chunks = 0